/* eslint-disable linebreak-style */
import React from 'react'
import { connect } from 'react-redux'
import { Route, Redirect } from 'react-router-dom'
import PropTypes from 'prop-types'
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min'
import qs from 'query-string'

export const PublicRoute = ({ isAuthenticated, component: Component, ...rest }) => {
  const history = useHistory()
  const querySearch = qs.parse(history.location.search)
  const redirectTo =
          history.location.pathname.includes('/auth/login') || history.location.pathname === '/'
            ? querySearch.redirectTo || '/'
            : history.location.pathname

  if (isAuthenticated && localStorage.getItem('email')) {
    localStorage.removeItem('email')
  }

  return (
    <Route
      {...rest}
      render={props => (isAuthenticated
        ? <Redirect to={redirectTo} />
        : <Component {...props} />)}
    />
  )
}

PublicRoute.propTypes = {
  isAuthenticated: PropTypes.bool.isRequired,
  component: PropTypes.elementType.isRequired
}

const mapStateToProps = state => ({
  isAuthenticated: !!state.auth.token
})

export default connect(mapStateToProps, null, null, { pure: false })(PublicRoute)
